<template>

  <div class="head">
    <headr :menuIndex=3></headr>

    <div id="pc">

      <span>关于海鸥</span>
      <span>海鸥APP是由成都争渡科技有限公司研发运营，海鸥是一款基于安全加密的聊天通讯工具，是中国安全领域的开放式社交平台之一。
        成都争渡科技有限公司成立于2020年，是一家以研发、运营为主的科技型公司，长期致力于软件开发。旗下的[海鸥]APP在2021年已推出，是一款主打安全加密聊天的手机通讯软件，为客户提供了安全稳定的聊天环境。现已在各大应用市场上线，上线累计用户已超500万+。</span>
      <span>企业文化及福利待遇</span>
      <div>
        <div>
          <img src="@/img/pc/yonghu@2x.png" alt="">
          <p>用户至上</p>
        </div>
        <div>
          <img src="@/img/pc/jiandna@2x.png" alt="">
          <p>简单开放</p>
        </div>
        <div>
          <img src="@/img/pc/chixu@2x.png" alt="">
          <p>持续进步</p>
        </div>
        <div>
          <img src="@/img/pc/zhuiqiu@2x.png" alt="">
          <p>追求本质</p>
        </div>
        <div>
          <img src="@/img/pc/baochi@2x.png" alt="">
          <p>保持年轻</p>
        </div>
        <div>
          <img src="@/img/pc/dingqi@2x.png" alt="">
          <p>定期团建</p>
        </div>
        <div>
          <img src="@/img/pc/daixin@2x.png" alt="">
          <p>带薪福利假</p>
        </div>
        <div>
          <img src="@/img/pc/quanqin@2x.png" alt="">
          <p>全勤奖</p>
        </div>
        <div>
          <img src="@/img/pc/xiawucha@2x.png" alt="">
          <p>下午茶</p>
        </div>
        <div>
          <img src="@/img/pc/jiejiari@2x.png" alt="">
          <p>节假日福利</p>
        </div>

      </div>
      <span>联系我们</span>
      <div>
        <img src="@/img/pc/Frame 3330@2x.png" alt="">
        <div>
          <span>成都争渡科技有限公司</span>
          <span>地址：四川省成都市高新区天府三街新希望国际B座23层09号</span>
          <span>邮编：610000</span>
          <span>广告合作及违规广告投诉举报反馈邮箱：haiouim@qq.com</span>
          <span>工作时间：周一至周五：09:30-18:30</span>
          <span>中国互联网举报中心：12377 </span>
        </div>
      </div>

    </div>


    <div id='mobile'>



      <span>关于海鸥</span>
      <span>海鸥APP是由成都争渡科技有限公司研发运营，海鸥是一款基于安全加密的聊天通讯工具，是中国安全领域的开放式社交平台之一。
        成都争渡科技有限公司成立于2020年，是一家以研发、运营为主的科技型公司，长期致力于软件开发。旗下的[海鸥]APP在2021年已推出，是一款主打安全加密聊天的手机通讯软件，为客户提供了安全稳定的聊天环境。现已在各大应用市场上线，上线累计用户已超500万+。</span>
      <span>企业文化及福利待遇</span>
      <div>
        <div>
          <img src="@/img/pc/yonghu@2x.png" alt="">
          <p>用户至上</p>
        </div>
        <div>
          <img src="@/img/pc/jiandna@2x.png" alt="">
          <p>简单开放</p>
        </div>
        <div>
          <img src="@/img/pc/chixu@2x.png" alt="">
          <p>持续进步</p>
        </div>
        <div>
          <img src="@/img/pc/zhuiqiu@2x.png" alt="">
          <p>追求本质</p>
        </div>
        <div>
          <img src="@/img/pc/baochi@2x.png" alt="">
          <p>保持年轻</p>
        </div>
        <div>
          <img src="@/img/pc/dingqi@2x.png" alt="">
          <p>定期团建</p>
        </div>
        <div>
          <img src="@/img/pc/daixin@2x.png" alt="">
          <p>带薪福利假</p>
        </div>
        <div>
          <img src="@/img/pc/quanqin@2x.png" alt="">
          <p>全勤奖</p>
        </div>
        <div>
          <img src="@/img/pc/xiawucha@2x.png" alt="">
          <p>下午茶</p>
        </div>
        <div>
          <img src="@/img/pc/jiejiari@2x.png" alt="">
          <p>节假日福利</p>
        </div>

      </div>
      <span>联系我们</span>
      <div>
        <img src="@/img/pc/Frame 3330@2x.png" alt="">
        <div>
          <span>成都争渡科技有限公司</span>
          <span>地址：四川省成都市高新区天府三街新希望国际B座23层09号</span>
          <span>邮编：610000</span>
          <span>广告合作及违规广告投诉举报反馈邮箱：haiouim@qq.com</span>
          <span>工作时间：周一至周五：09:30-18:30</span>
          <span>中国互联网举报中心：12377 </span>
        </div>
      </div>




    </div>


    <bottom></bottom>
<down ></down>
  </div>

</template>

<script>
  import api from "@/api/api";
  import request from '@/api/request';
  import headr from '@/components/head/index'
  import bottom from '@/components/bottom/index'
  import down from '@/components/down/index'
  import {
    Notify
  } from 'vant';
  import {
    Dialog
  } from 'vant';
  export default {
    components: {
      headr,
      bottom,
      down
    },
    data() {
      return {
        menuIndex: 0,
        jmInfoIndex: 0,
        menuYes: 'border-bottom: 4px solid #4371FF;color: #4371FF;height: 26px;',
        menuNo: 'border-bottom: 0px;color: #666666;height: 26px;',

        jmInfoIndexYes: 'border-bottom: 2px solid #4371FF;color: #4371FF;',
        jmInfoIndexNo: 'border-bottom: 2px solid #E0E0E0;color: #666666;',


      }
    },
    created() {

    },
    computed: {

    },
    mounted() {


    },

    destroyed() {

    },
    methods: {


    }
  }

</script>

//pc端
<style scoped>
  /* 当屏幕宽度大于或等于768像素时，改为浮动布局 */
  @media (min-width: 768px) {

    #mobile {
      display: none;
    }

    #pc {

      display: flex;
      flex-flow: column;
      align-items: center;
    }

    #pc>span:nth-child(1) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #333333;
      line-height: 38px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 80px;

    }

    #pc>span:nth-child(2) {
      width: 1360px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
      line-height: 30px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 44px;
    }

    #pc>span:nth-child(3) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #333333;
      line-height: 38px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 120px;
    }

    #pc>div:nth-child(4) {
      width: 1570px;

      display: flex;
      flex-flow: row;
      flex-wrap: wrap;
      align-items: center;


      margin-top: 70px;
    }

    #pc>div:nth-child(4)>div {
      width: 104px;
      height: 142px;
      margin-right: 105px;
      margin-left: 105px;
      margin-bottom: 72px;
    }

    #pc>div:nth-child(4)>div>img {
      width: 104px;
      height: 104px;
    }

    #pc>div:nth-child(4)>div>p {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      line-height: 19px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 16px;
      margin-bottom: 0;
    }






    #pc>span:nth-child(5) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #333333;
      line-height: 38px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 100px;
    }

    #pc>div:nth-child(6) {
      position: relative;
      margin-top: 70px;
      margin-bottom: 175px;
    }

    #pc>div:nth-child(6)>img {

      width: 1360px;
      height: 400px;
    }

    #pc>div:nth-child(6)>div {
      width: 454px;
      height: 332px;
      padding-right: 24px;
      padding-left: 24px;
      position: absolute;
      left: 254px;
      top: 0;
      background-color: #4371FF;
      opacity: 0.8;
      display: flex;
      flex-flow: column;
      align-items: flex-start;

      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;


    }


    #pc>div:nth-child(6)>div>span {
      margin-top: 24px;
    }

    #pc>div:nth-child(6)>div>span:first-child {
      font-size: 24px;
    }

  }

</style>

//移动端
<style scoped>
  /* 当屏幕宽度小于或等于768像素时，应用以下样式 */
  @media (max-width: 768px) {
    #pc {
      display: none;
    }


#mobile {

      display: flex;
      flex-flow: column;
      align-items: center;
    }

    #mobile>span:nth-child(1) {
font-family: PingFang SC, PingFang SC;
font-weight: 500;
font-size: 18px;
color: #333333;
line-height: 21px;
text-align: center;
font-style: normal;
text-transform: none;
      margin-top: 72px;

    }

    #mobile>span:nth-child(2) {
width: 303px;
height: 198px;
background: #FFFFFF;
box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.05);
border-radius: 4px 4px 4px 4px;
      margin-top: 16px;
      padding:16px 16px 16px 16px;

      font-family: PingFang SC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: #666666;
line-height: 22px;
text-align: left;
font-style: normal;
text-transform: none;
    }

    #mobile>span:nth-child(3) {
font-family: PingFang SC, PingFang SC;
font-weight: 500;
font-size: 18px;
color: #333333;
line-height: 21px;
text-align: center;
font-style: normal;
text-transform: none;
      margin-top: 44px;
    }

    #mobile>div:nth-child(4) {
     

      display: flex;
      flex-flow: row;
      flex-wrap: wrap;
      align-items: center;


      margin-top: 24px;
      margin-left: 8px;
    }

    #mobile>div:nth-child(4)>div {
      width: 72px;
      height: 57px;
     
      margin-bottom: 24px;
    }

    #mobile>div:nth-child(4)>div>img {
      width: 32px;
      height: 32px;
    }

    #mobile>div:nth-child(4)>div>p {
font-family: PingFang SC, PingFang SC;
font-weight: 400;
font-size: 12px;
color: #333333;
line-height: 14px;
text-align: center;
font-style: normal;
text-transform: none;
      margin-top: 8px;
      margin-bottom: 0;
    }






    #mobile>span:nth-child(5) {
font-family: PingFang SC, PingFang SC;
font-weight: 500;
font-size: 18px;
color: #333333;
line-height: 21px;
text-align: center;
font-style: normal;
text-transform: none;
      margin-top: 49px;
    }

    #mobile>div:nth-child(6) {
      position: relative;
      margin-top: 24px;
      margin-bottom: 48px;
    }

    #mobile>div:nth-child(6)>img {

      width: 335px;
      height: 247px
    }

    #mobile>div:nth-child(6)>div {
width: 243px;
height: 199px;
      padding-right: 12px;
      padding-left: 12px;
      position: absolute;
      left: 46px;
      top: 0;
      background-color: #4371FF;
      opacity: 0.8;
      display: flex;
      flex-flow: column;
      align-items: flex-start;

font-family: PingFang SC, PingFang SC;
font-weight: 400;
font-size: 12px;
color: #FFFFFF;
line-height: 14px;
text-align: left;
font-style: normal;
text-transform: none;


    }


    #mobile>div:nth-child(6)>div>span {
      font-size: 12px;
      margin-top: 10px;
    }

    #mobile>div:nth-child(6)>div>span:first-child {
      font-size: 14px;
    }






  }

</style>



// WEBPACK FOOTER //
// src/view/aboutUs/index.vue